import React from 'react';

import { formatSubject } from 'modules/dtm';

interface IProps {
  subject: string;
}

export const Header = ({ subject }: IProps) => (
    <div className="flex items-center justify-between rounded-2xl bg-white px-4 py-3">
      <h1 className="text-lg font-medium">{formatSubject(subject)}</h1>
    </div>
  );
